import { CleryBioProfessionalItem } from '../../model/clergy-bio-app-models';

export const deleteAction = 'delete';

export interface ClergyBioProfessionalFormModel {
	publications: CleryBioProfessionalItem[];
	honors: CleryBioProfessionalItem[];
	societies: CleryBioProfessionalItem[];
	optOut: boolean;
}